import { useAuth } from "../../../../context/AuthContext.jsx";
import { useConsultation } from "../../../../context/ConsultationContext.jsx";

/**
 * Helper function to determine navigation destination for treatment services
 * @param {Object} location - React Router location object
 * @param {Object} navigate - React Router navigate function
 * @param {Object} consultationData - Consultation context data
 * @param {Function} updateConsultationData - Function to update consultation data
 * @param {Function} getStepDraft - Function to get step draft data
 * @param {Function} setStepDraft - Function to set step draft data
 * @param {Function} goToStep - Function to set current step (optional)
 * @param {Object} serviceData - Service-specific data to save
 */
export const handleTreatmentServiceNavigation = ({
  location,
  navigate,
  consultationData,
  updateConsultationData,
  getStepDraft,
  setStepDraft,
  goToStep,
  serviceData,
}) => {
  // Get user info from localStorage or AuthContext
  const storedUser = (() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  })();
  
  const user = storedUser;
  const isPCDT = Number(user?.roleid) === 8;

  // Save service data to step drafts
  const st = location?.state || {};
  const workflowServiceId =
    consultationData?.activeWorkflowServiceId ||
    st.addedServiceId ||
    st.serviceId ||
    st.serviceid ||
    consultationData?.serviceId;

  const existing = getStepDraft?.('serviceWorkflowData', {}) || {};
  const existingForService = (workflowServiceId && existing?.[workflowServiceId]) ? existing[workflowServiceId] : {};

  setStepDraft?.('serviceWorkflowData', {
    ...existing,
    ...(workflowServiceId ? {
      [workflowServiceId]: {
        ...(existingForService || {}),
        ...serviceData,
      },
    } : {}),
  });

  // Update consultation data with returnedFromWorkflow flag
  updateConsultationData({ returnedFromWorkflow: true });

  // Update consultation data with basic info
  const nextData = {};
  const patientId = st.patientId ?? st.patientid;
  const appointmentId = st.appointmentId ?? st.appointmentid;
  const serviceId = st.serviceId ?? st.serviceid;

  if (patientId && !consultationData?.patientId) nextData.patientId = patientId;
  if (appointmentId && !consultationData?.appointmentId) nextData.appointmentId = appointmentId;
  if (serviceId && !consultationData?.serviceId) nextData.serviceId = serviceId;
  if (Object.keys(nextData).length) updateConsultationData?.(nextData);

  // Navigate based on user role
  if (isPCDT) {
    // PCDT users go to prescription step
    // Set current step to 9 to ensure sidebar shows correct steps
    goToStep?.(9);
    
    navigate('/customer/clinic/prescription', {
      state: {
        ...(location?.state || {}),
        returnedFromWorkflow: true,
      },
    });
  } else {
    // Other users go to invoice
    navigate('/customer/clinic/invoice', {
      state: {
        ...(location?.state || {}),
        returnedFromWorkflow: true,
      },
    });
  }
};
